import { VISIT_SEARCH_SELECT_OPTIONS } from '~services/constant/visit';
import HelperOptions from '~component/helper/helper-options';

// 搜索拜访记录的下拉框，对应的字段类型
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;

    return (
      <HelperOptions
        { ...data }
        options={ VISIT_SEARCH_SELECT_OPTIONS }
      />
    );
  },
};
